export default {
  path: '/tool_extruders',
  name: 'tool_extruders',
  component: () => import('../components/toolextruder/Layout'),
  redirect: { name: 'ToolExtruderList' },
  meta: {
    breadcrumb: 'profile.tool.extruders',
  },
  children: [
    {
      name: 'ToolExtruderList',
      path: '',
      component: () => import('../views/toolextruder/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ToolExtruderCreate',
      path: 'new',
      component: () => import('../views/toolextruder/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ToolExtruderUpdate',
      path: ':id/edit',
      component: () => import('../views/toolextruder/Update'),
      meta: {
        breadcrumb: 'profile.tool.extruder',
      },
    },
    {
      name: 'ToolExtruderShow',
      path: ':id',
      component: () => import('../views/toolextruder/Show'),
      meta: {
        breadcrumb: 'profile.tool.extruder',
      },
    }
  ]
};
